import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

import { Wrapper } from "../Grid";

const FooterTopWrapper = styled(Wrapper)(props => {
  return {
    borderTop: `4px solid ${themeGet("colors.footer.mail")(props)}`,
    backgroundColor: themeGet("colors.footer.bg.top")(props),
    color: themeGet("colors.white.100")(props),
  };
});

FooterTopWrapper.displayName = "FooterTopWrapper";

export default FooterTopWrapper;
